export function getQueryValue(variable: string): string | undefined {
  if (window.location.search) {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has(variable)) {
      return searchParams.get(variable) ?? undefined;
    }
  }
  return undefined;
}